import { useState, useEffect } from 'react'
import { pushToWindowResize, removeFromWindowResize } from 'src/helpers/browser'
import { useUniqueId } from 'src/hooks'
import { YLOPO_BASE_URL } from 'src/constants/ylopo'

const buildHBIdParam = function (clientId) {
  return `?hbid=${clientId}`
}

const buildZipParam = function (index, zipcode) {
  return `&s[locations][${index}][postalCode]=${zipcode}`
}

export const buildListingUrl = function (clientId, listing) {
  const hbidParam = buildHBIdParam(clientId)
  const zipParam = buildZipParam(0, listing.address.postalCode)

  return `${YLOPO_BASE_URL}/detail/${listing.id}${hbidParam}${zipParam}`
}

export const buildMultiZipSearchUrl = function (clientId, markets) {
  const hbidParam = buildHBIdParam(clientId)

  const multiZipSearchParams = markets
    .map(({ zipcode }, index) => {
      return buildZipParam(index, zipcode)
    })
    .join('')

  return `${YLOPO_BASE_URL}${hbidParam}${multiZipSearchParams}`
}

export const buildSingleZipSearchUrl = function (clientId, zipcode) {
  const hbidParam = buildHBIdParam(clientId)
  const zipParam = buildZipParam(0, zipcode)

  return `${YLOPO_BASE_URL}${hbidParam}${zipParam}`
}

export const buildWithLongLatParam = (lat, lng, radius) => {
  return `?s[circle][lat]=${lat}&s[circle][lng]=${lng}&s[circle][radius]=${radius}`
}

export const buildViewAllSearchUrl = ({
  circle,
  radius,
  minPrice,
  maxPrice,
  orderBy
}) => {
  const longLatParam = buildWithLongLatParam(
    circle.lat,
    circle.lng,
    circle.radius
  )
  const minMaxParam = buildPriceRangeParams(minPrice, maxPrice)
  const orderByParam = buildOrderByParams(orderBy)

  return `${YLOPO_BASE_URL}${longLatParam}${minMaxParam}${orderByParam}`
}

export const buildPriceRangeParams = function (minPrice, maxPrice) {
  return `&s[minPrice]=${minPrice}&s[maxPrice]=${maxPrice}`
}

export const buildOrderByParams = orderBy => {
  return `&s[orderBy]=${orderBy}`
}

const isScreenLargeEnoughForMap = () =>
  window.innerHeight > 649 && window.innerWidth > 799

const transformYlopoUrl = getter => url => {
  const id = useUniqueId('YlopoLinkSizer_')
  const [needsTransform, setNeedsTransform] = useState(getter())
  const toMap = needsTransform ? '/map' : ''

  useEffect(() => {
    pushToWindowResize(id, () => setNeedsTransform(getter()))
    return () => removeFromWindowResize(id)
  }, [id])

  return (
    !!url &&
    url.replace(
      new RegExp(`${YLOPO_BASE_URL}(/map)?`),
      `${YLOPO_BASE_URL}${toMap}`
    )
  )
}

export const transformYlopoUrlForSizeHook = transformYlopoUrl(
  isScreenLargeEnoughForMap
)
